import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "@/store";

const initialState = {} as IAlert;

const alertSlice = createSlice({
    name: "alert",
    initialState,
    reducers: {
        setAlert: (state, action: PayloadAction<IAlert | undefined>) => {
            Object.assign(state, action.payload);
        },
    },
});

export const { setAlert } = alertSlice.actions;
export default alertSlice.reducer;

export const getAlert = (state: RootState) => state.alert;
